import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type { ResearchTeammatesToolOutput } from "@repo/app-types/agents/researchTeammatesTool";
import { renderPlural } from "@repo/app-types/helpers/utilities";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const ResearchTeammatesTool: ToolComponent<
  unknown,
  ResearchTeammatesToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Reviewing teammate performance...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while reviewing teammate performance";
    }

    return renderPlural(props.output.findings.length, {
      zero: "No teammates reviewed",
      one: "Reviewed performance of 1 teammate",
      other: (count) =>
        `Reviewed performance of ${count.toLocaleString()} teammates`,
    });
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
